import {
  ASK_NAVI_AGENT_CONFIG,
} from '../config/ask-navi-agent.config';

/** Minimal shape needed to test whether a list row belongs to Ask Navi. */
export interface AskNaviConversationMetadataSource {
  metadata?: Record<string, unknown>;
}

/**
 * Returns true when conversation list metadata matches {@link ASK_NAVI_AGENT_CONFIG}.
 * Used to hide BrightNav and other copilot conversations from the Ask Navi sidebar.
 *
 * @param item - Row from `GET /conversation/list`.
 */
export function isAskNaviConversation(item: AskNaviConversationMetadataSource): boolean {
  const meta = item.metadata ?? {};
  return (
    meta['namespace_id'] === ASK_NAVI_AGENT_CONFIG.namespaceId &&
    meta['agent_id'] === ASK_NAVI_AGENT_CONFIG.agentId &&
    meta['agent_alias_id'] === ASK_NAVI_AGENT_CONFIG.agentAliasId &&
    meta['agent_framework'] === ASK_NAVI_AGENT_CONFIG.agentFramework
  );
}
